export function clearThumbnailCache() {
  // no-op
}

export function VideoTranscodeBackdrop() {
  return null
}
